import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMedicineTablett: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconMedicineTablett"><Path d="M11.8951 3.89701C14.1614 1.63069 17.8358 1.63068 20.1022 3.89701C22.3685 6.16334 22.3685 9.83779 20.1022 12.1041L16.4557 15.7506L8.24861 7.54346L11.8951 3.89701Z" fill="currentColor"/><Path d="M7.54151 8.25057L3.89506 11.897C1.62873 14.1633 1.62873 17.8378 3.89506 20.1041C6.16139 22.3704 9.83584 22.3704 12.1022 20.1041L15.7486 16.4577L7.54151 8.25057Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMedicineTablett;
